import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Role } from "@/lib/users.api";
import { USER_ROLE_FILTER_OPTIONS, type UsersPageViewMode } from "../usersPage.constants";
import { UsersViewToggle } from "./UsersViewToggle";

interface UsersToolbarProps {
  search: string;
  roleFilter: Role | "";
  viewMode: UsersPageViewMode;
  total: number;
  onSearchChange: (search: string) => void;
  onRoleFilterChange: (role: Role | "") => void;
  onViewModeChange: (viewMode: UsersPageViewMode) => void;
}

export function UsersToolbar({
  search,
  roleFilter,
  viewMode,
  total,
  onSearchChange,
  onRoleFilterChange,
  onViewModeChange,
}: UsersToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 border-y border-border py-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-1 flex-col gap-2 sm:flex-row">
        <Input
          placeholder="Rechercher par nom ou email..."
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          className="max-w-xs"
        />
        <Select
          value={roleFilter || "__all__"}
          onValueChange={(value) => onRoleFilterChange(value === "__all__" ? "" : (value as Role))}
        >
          <SelectTrigger className="w-44">
            <SelectValue placeholder="Tous les rôles" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">Tous les rôles</SelectItem>
            {USER_ROLE_FILTER_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center justify-between gap-3">
        <p className="text-[11.5px] text-muted-foreground">
          {total} résultat{total !== 1 ? "s" : ""}
        </p>
        <UsersViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
      </div>
    </div>
  );
}
